import { flow, types } from 'mobx-state-tree';
import { getEnvironment } from '../utils/utils';
import moment from 'moment';
// import { nullType } from 'mobx-state-tree/dist/internal';

export const PharmacyFilters = types.model({
  pharmaciesActiveFilter: types.maybe(types.string),
  pharmaciesLevelFilter: types.maybe(types.string),
  pharmacyYearFirstLine: types.number,
  pharmacyYearSecondLine: types.number,
  lastSelectedPharmacy: types.number,
  diagnosticPageActiveTab: types.maybe(types.string),
  diagnosticPageActiveSubTab: types.maybe(types.string),
  diagnosticPageStartDate: types.optional(types.maybeNull(types.Date), undefined),
  diagnosticPageEndDate: types.maybeNull(types.Date),
  diagnosticPageCurrentPlanningId: types.number,
  diagnosticOffset: types.number,
  pharmacyPageActiveTab: types.maybe(types.string),
  showDutiesOnMapDate: types.number,
});

export const UiStore = types
  .model('UiStore', {
    pharmaciesActiveFilter: 'active',
    pharmaciesLevelFilter: 'all',
    pharmaciesGroupFilter: '',
    pharmaciesTextFilter: '',
    pharmaciesSecretariatIdFilter: types.optional(types.union(types.number, types.undefined), () => 0),
    pharmacyFirstLineYear: moment().year(),
    pharmacySecondLineYear: moment().year(),
    lastSelectedPharmacy: 0,
    diagnosticPageActiveTab: '',
    diagnosticPageActiveSubTab: '',
    diagnosticPageFirstDate: types.optional(types.maybeNull(types.Date), undefined),
    diagnosticPageStartDate: types.optional(types.maybeNull(types.Date), undefined),
    diagnosticPageEndDate: types.optional(types.maybeNull(types.Date), undefined),
    diagnosticPageCurrentPlanningId: -1,
    diagnosticPagePrevPlanningId: -1,
    diagnosticPageCurrentSemesterYear: new Date().getFullYear(),
    diagnosticOffset: -1,
    diagnosticSearchStatus: types.optional(types.model({ label: types.string, value: types.string }), {
      label: 'publié',
      value: 'published',
    }),
    pharmacyPageActiveTab: '',
    showDutiesOnMapDate: moment().format('YYYY-MM-DD'),
    centerCoordinates: types.optional(types.model({ lat: types.number, lng: types.number }), {
      lat: 50.58603,
      lng: 3.806026,
    }),
  })
  .actions((self) => {
    const env = getEnvironment(self);
    const apiFetcher = env.api;

    const setPharmaciesActiveFilter = function(filter) {
      self.pharmaciesActiveFilter = filter;
    };

    const setPharmaciesLevelFilter = function(filter) {
      self.pharmaciesLevelFilter = filter;
    };

    const setPharmaciesGroupFilter = function(filter) {
      self.pharmaciesGroupFilter = filter;
    };

    const setPharmaciesTextFilter = function(filter) {
      self.pharmaciesTextFilter = filter;
    };

    const setPharmaciesSecretariatIdFilter = function(filter: number | undefined) {
      self.pharmaciesSecretariatIdFilter = filter;
    };

    const setPharmacyCalendarYear = function(year) {
      self.pharmacyFirstLineYear = year;
      self.pharmacySecondLineYear = year;
    };

    const setDiagnosticPageActiveTab = function(tab) {
      self.diagnosticPageActiveTab = tab;
    };

    const setDiagnosticPageActiveSubTab = function(tab) {
      self.diagnosticPageActiveSubTab = tab;
    };

    const setDiagnosticPageFirstDate = function(date) {
      self.diagnosticPageFirstDate = date;
    };

    const setDiagnosticPageStartDate = function(date) {
      self.diagnosticPageStartDate = date;
    };

    const setDiagnosticPageEndDate = function(date) {
      self.diagnosticPageEndDate = date;
    };

    const setDiagnosticPageCurrentPlanningId = function(id) {
      self.diagnosticPageCurrentPlanningId = id;
    };
    const setDiagnosticPageCurrentSemesterYear = function(year) {
      self.diagnosticPageCurrentSemesterYear = year;
    };
    const setPharmacyPageActiveTab = function(tab) {
      self.pharmacyPageActiveTab = tab;
    };

    const setShowDutiesOnMapDate = function(showDate) {
      self.showDutiesOnMapDate = showDate;
    };

    const setLastSelectedPharmacy = function(pharmacyId) {
      self.lastSelectedPharmacy = pharmacyId;
    };

    const setCenterCoordinates = function(coordinates) {
      self.centerCoordinates = coordinates;
    };

    const setDiagnosticOffset = function(offset) {
      self.diagnosticOffset = offset;
    };

    const setDiagnosticPagePrevPlanningId = function(prevPlanningId) {
      self.diagnosticPagePrevPlanningId = prevPlanningId;
    };

    const setDiagnosticSearchStatus = function(status) {
      self.diagnosticSearchStatus = status;
    };

    return {
      afterAttach: flow(function*() {}),
      setPharmaciesActiveFilter,
      setPharmaciesLevelFilter,
      setPharmaciesGroupFilter,
      setPharmaciesTextFilter,
      setPharmaciesSecretariatIdFilter,
      setPharmacyCalendarYear,
      setDiagnosticPageActiveTab,
      setDiagnosticPageActiveSubTab,
      setDiagnosticPageStartDate,
      setDiagnosticPageFirstDate,
      setDiagnosticPageEndDate,
      setDiagnosticPageCurrentPlanningId,
      setDiagnosticPagePrevPlanningId,
      setDiagnosticPageCurrentSemesterYear,
      setDiagnosticSearchStatus,
      setPharmacyPageActiveTab,
      setShowDutiesOnMapDate,
      setLastSelectedPharmacy,
      setCenterCoordinates,
      setDiagnosticOffset,
    };
  });
